import React from 'react';
import { Toast } from 'primereact/toast';

interface ToastNotificationProps {
  toastRef: React.MutableRefObject<Toast | null>;
}

const ToastNotification: React.FC<ToastNotificationProps> = ({ toastRef }) => {
  return <Toast ref={toastRef} position="bottom-right" />;
};

export default ToastNotification;
